
import { debug, george, inject, observer, React, ui } from "aaa";
import auth from "stores/AuthStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import {
    isAccidentInsurance,
    isBankCard,
    isConsumerLoan,
    isCreditCard,
    isSalaryAdvanceCard,
    isSavingsAccount,
    OffersStore,
    isLifeInsurance,
    isNewCreditCard
} from "stores/OffersStore";
import { pushRoute, routerData } from "stores/RouterFunctions";
import ErrorScreen from "components/common/ErrorScreen";

/**
 * Class is ONLY use for redirecting to corresponding shop
 */
@inject("externalInterfaceStore")
@observer
export class Shop extends React.Component<{}, { isProductUnavailable: boolean }> {
    offersStore = new OffersStore();

    state = {
        isProductUnavailable: false
    };

    // MUST have ctor to satisfy Typescript
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        if (auth.authorized &&
            externalInterfaceStore.channelProduct
        ) {
            debug.log("### Starting shop");
            debug.log("###    productId", externalInterfaceStore.productId);
            debug.log("###    conditionsGroupId", externalInterfaceStore.conditionsGroupId);
            debug.log("###    channelProduct", externalInterfaceStore.channelProduct);

            const channelProduct = externalInterfaceStore.channelProduct;

            await this.offersStore.load();

            const offer = this.offersStore.findByChannelProduct(externalInterfaceStore.channelProduct);

            if (offer) {
                if (!isAccidentInsurance(channelProduct) && !isLifeInsurance(channelProduct) && !isConsumerLoan(channelProduct)) {
                    const productId = offer.productId;
                    const conditionsGroupId = offer.conditionsGroupId;

                    routerData.queryParams = {
                        ...routerData.queryParams,
                        channelProduct,
                        productId,
                        conditionsGroupId
                    };
                }

                if (isCreditCard(channelProduct) || isSalaryAdvanceCard(channelProduct) || isNewCreditCard(channelProduct)) {
                    pushRoute("/shop-credit-card");
                } else if (isBankCard(channelProduct)) {
                    pushRoute("/shop-bank-card");
                } else if (isConsumerLoan(channelProduct)) {
                    pushRoute("/consumer-loan");
                } else if (isSavingsAccount(channelProduct)) {
                    pushRoute("/shop-savings");
                } else if (isAccidentInsurance(channelProduct)) {
                    pushRoute("/accident-insurance");
                } else if (isLifeInsurance(channelProduct)) {
                    pushRoute("/life-insurance");
                } else {
                    pushRoute("/unauthorized");
                }
            } else {
                this.setState({ isProductUnavailable: true });
            }
        } else {
            pushRoute("/unauthorized");
        }
    }

    render() {
        return (
            <div>
                {this.offersStore.isLoading && <george.LoadingIndicator isLoading={this.offersStore.isLoading} height={window.innerHeight} />}
                {!this.offersStore.isLoading && this.state.isProductUnavailable && (
                    <ErrorScreen
                        useWebVersion
                        externalInterfaceStore={externalInterfaceStore}
                        title={ui.__("shop.productUnavailable.title")}
                        message={ui.__("shop.productUnavailable.message")}
                        buttonLabelId="common.backToGeorgeGo"
                    />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop/Shop.tsx